module.exports = __webpack_public_path__ + "static/media/nothing.caa37b8a.jpg";